"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListResponseIntegrationOut = void 0;
class ListResponseIntegrationOut {
    constructor() {
    }
    static getAttributeTypeMap() {
        return ListResponseIntegrationOut.attributeTypeMap;
    }
}
exports.ListResponseIntegrationOut = ListResponseIntegrationOut;
ListResponseIntegrationOut.discriminator = undefined;
ListResponseIntegrationOut.attributeTypeMap = [
    {
        "name": "data",
        "baseName": "data",
        "type": "Array<IntegrationOut>",
        "format": ""
    },
    {
        "name": "done",
        "baseName": "done",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "iterator",
        "baseName": "iterator",
        "type": "string",
        "format": ""
    },
    {
        "name": "prevIterator",
        "baseName": "prevIterator",
        "type": "string",
        "format": ""
    }
];
//# sourceMappingURL=ListResponseIntegrationOut.js.map